import { combineReducers } from 'redux'
import { types } from './ReadOnlyActions'

const open = (state = false, action) => {
	switch (action.type) {
		case types.OPEN: {
			return true
		}
		case types.CLOSE: {
			return false
		}
		default:
			return state
	}
}

export default combineReducers({
	open
})
